import { Box, Typography } from '@mui/material'
import React from 'react'
// import logo from './../../assets/Logo/logo.png'
const Bio = ({ bio, data }) => {
    return (
        <>
            <Box sx={{ position: 'relative', zIndex: 2, width: '100%', mb: 1, mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography color='footer.link' fontWeight={500} variant='h5'
                    sx={{ position: 'relative', zIndex: 3, fontSize: {xl:'30px',md:'24px',xs:'20px'}, lineHeight: '45px' }} >
                    {data?.footerBioFirstLine} <Typography variant='h5' component={'span'}
                        color={'secondary.main'} sx={{ fontSize: {xl:'30px',md:'24px',xs:'20px'}, lineHeight: '45px' }} >{' ' + data?.footerBioFirstLineColored}</Typography>
                </Typography>
                <Typography color='footer.link' fontWeight={'normal'} variant='body2'
                    sx={{ position: 'relative', zIndex: 3, fontSize: {xl:'18px',md:'15px',xs:'14px'}, lineHeight: '45px', fontWeight: 300 }} >
                    {data?.footerBioSecondLine}
                </Typography>
                <Typography color='footer.link' fontWeight={'normal'}
                    sx={{ position: 'relative', zIndex: 3, fontSize: {xl:'20px',md:'16px',xs:'14px'}, lineHeight: '33px', fontWeight: 300 }} >
                    {data?.footerBioThirdLine}
                </Typography>
            </Box>
        </>
    )
}

export default Bio